import React from 'react';
import { Button } from 'antd';

export function UnauthorizedPage() {
  const startLogin = () => {
    const url = (process.env.REACT_APP_ISG_BASE_API_URL || window.location.protocol + '//' + window.location.host) + '/login-password';
    window.location.href = url;
  };

  return (
    <div style={{ padding: '15rem 0', textAlign: 'center' }}>
      <h1>Hata!</h1>
      <h3>Bu uygulamayı kullanmak için yetkiniz bulunmuyor.</h3>
      <p>
        Detaylı bilgi için <a href="mailto:info@leanapp.com.tr">info@leanapp.com.tr</a> adresiyle iletişime geçebilirsiniz.
      </p>
      <Button type="default" style={{ marginTop: '3rem' }} onClick={startLogin}>
        Tekrar dene
      </Button>
    </div>
  );
}
